<div style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px;">
    <span style="font-weight: bold;">Prepare PP Returns:</span>
    @if (entity.typeId === EntityTypeIds.COMPANY) {
        <ws-switch
            size="small"
            [(ngModel)]="entity.ppReturnPreparationAllowed"
            [disabled]="!entity.isTopLevel || !editMode || !hasCompliancePermission || isConsultantPerspective"
            (selectedOptionChanged)="maybePopulateBatchUsers()"
            data-qa="compliance-returns-prepare-pp-returns-company">
        </ws-switch>
    }
    @if (entity.typeId !== EntityTypeIds.COMPANY) {
        <ws-switch
            size="small"
            [(ngModel)]="currentData.ppReturnPreparationAllowed"
            [disabled]="!entity.isTopLevel || !editMode || !hasCompliancePermission || isConsultantPerspective"
            (selectedOptionChanged)="maybePopulateBatchUsers()"
            data-qa="compliance-returns-prepare-pp-returns-non-company">
        </ws-switch>
    }
</div>
@if (entity.typeId === EntityTypeIds.COMPANY ? entity.ppReturnPreparationAllowed : currentData.ppReturnPreparationAllowed) {
    <div>
        @for (userType of DR_USERS; track userType; let i = $index) {
            <div style="display: flex; align-items: center;">
                <div style="min-width: 150px;">{{ userType.name }}:</div>
                @if (editMode && entity.isTopLevel && users) {
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <user-team-picker
                            style="width: 300px;"
                            [userId]="currentData[userType.prefix + 'UserId']"
                            [teamId]="currentData[userType.prefix + 'TeamId']"
                            [entityIdScope]="entity.id"
                            [entityTypeScope]="entity.type"
                            [instanceIdScope]="userSearchInstanceId"
                            (userChange)="userChanged($event, userType.prefix)"
                            [required]="userType.required"
                            [parentUsers]="users"
                            [disabled]="!editMode"
                            [attr.data-qa]="'compliance-returns-user-picker-' + i"
                        ></user-team-picker>
                        @if (!userType.required) {
                            <button
                                class="ace-btn has-icon btn-primary btn-danger"
                                style="margin:0;"
                                (click)="userChanged(undefined, userType.prefix)"
                                [attr.data-qa]="'compliance-returns-clear-user-' + i">
                                <i class="fa fa-trash"></i>
                            </button>
                        }
                    </div>
                }
                @if (currentData[userType.prefix + 'User'] && (!editMode || !entity.isTopLevel)) {
                    <div>
                        {{ getDisplayName(currentData[userType.prefix + 'User'], currentData[userType.prefix + 'Team']) }}
                    </div>
                }
            </div>
        }
    </div>
}
